(() => {
  // Progressive enhancement: without JavaScript every answer remains readable.
  document.querySelectorAll('[data-info-faq]').forEach(root => {
    if (root.dataset.enhanced) return;
    root.dataset.enhanced = 'true';
    let answer;
    let index = 0;
    Array.from(root.children).forEach(child => {
      if (/^H[23]$/.test(child.tagName)) {
        const details = document.createElement('details');
        details.className = 'info-faq';
        details.open = index++ === 0;
        const summary = document.createElement('summary');
        const heading = document.createElement('h2');
        heading.textContent = child.textContent;
        summary.append(heading);
        answer = document.createElement('div');
        answer.className = 'info-faq__answer';
        details.append(summary, answer);
        child.replaceWith(details);
      } else if (answer) {
        answer.append(child);
      }
    });
  });
  document.querySelectorAll('[data-info-table] th').forEach(th => { th.scope = 'col'; });
  document.querySelectorAll('[data-info-privacy]').forEach(root => {
    const heading = root.querySelector('h2');
    const title = root.closest('.info-main')?.querySelector('h1');
    const normalize = text => text.trim().replace(/\s+/g, ' ').toLocaleLowerCase('pt-BR');
    if (heading?.matches('h2') && title && normalize(heading.textContent) === normalize(title.textContent)) heading.hidden = true;
  });
  const policy = document.querySelector('.shopify-policy__body');
  if (policy) {
    const firstParagraph = policy.querySelector('p');
    if (firstParagraph && /^Última atualização:/i.test(firstParagraph.textContent.trim())) firstParagraph.classList.add('policy-updated');
    const headings = Array.from(policy.querySelectorAll('h2'));
    if (headings.length > 2) {
      const details = document.createElement('details');
      details.className = 'info-toc';
      const summary = document.createElement('summary');
      summary.textContent = document.querySelector('script[data-contents-label]')?.dataset.contentsLabel || document.title;
      const list = document.createElement('ul');
      headings.forEach((heading, i) => {
        if (!heading.id) heading.id = `policy-section-${i + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link); list.append(item);
      });
      details.append(summary, list); policy.before(details);
      policy.closest('.shopify-policy__container')?.classList.add('policy--indexed');
      const desktop = window.matchMedia('(min-width: 990px)');
      const setIndexState = () => { details.open = desktop.matches; };
      setIndexState();
      desktop.addEventListener('change', setIndexState);
    }
  }
})();
